module.exports = __webpack_public_path__ + "img/d201208-2.ab55cae1.jpg";